import { render, staticRenderFns } from "./formuls-fraction.vue?vue&type=template&id=15a18062&scoped=true&"
import script from "./formuls-fraction.vue?vue&type=script&lang=js&"
export * from "./formuls-fraction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a18062",
  null
  
)

export default component.exports